import { useEffect, useMemo, useState } from 'react'
import { useClientResolution } from 'utils/hooks'
import { BANNER_WIDTH } from 'vars/banner-width'

type useBannerAdaptiveWidthProps = {
  width: BANNER_WIDTH
  childrenLength: number
}

const BANNER_WIDTH_NUMBER = {
  [BANNER_WIDTH.SIZE_100]: 100,
  [BANNER_WIDTH.SIZE_94]: 94.16,
  [BANNER_WIDTH.SIZE_66]: 66,
}

type useBannerAdaptiveWidthReturn = {
  adaptiveWidth: BANNER_WIDTH
  visibleCards: number
}

export const useBannerAdaptiveWidth = ({
  width,
  childrenLength,
}: useBannerAdaptiveWidthProps): useBannerAdaptiveWidthReturn => {
  const widthClient = useClientResolution().width
  const [adaptiveWidth, setAdaptiveWidth] = useState<BANNER_WIDTH>(
    BANNER_WIDTH.SIZE_100
  )
  const visibleCards = useMemo(
    () => adaptiveWidth && Math.ceil(+BANNER_WIDTH_NUMBER[adaptiveWidth] / 100),
    [adaptiveWidth]
  )
  useEffect(() => {
    if (widthClient > 1239 && childrenLength > 1) setAdaptiveWidth(width)
  }, [widthClient, width, childrenLength])

  return { adaptiveWidth, visibleCards }
}
